import * as angular from "angular";
import {IController} from "angular";

import {PredefinedSkillType} from "../../types/predefined-skill.type";

export class SkillsTableRowCtrl implements IController {

  skillsTableCtrl: any;
  skill: any;

  public predefinedSkillTypesMap: typeof PredefinedSkillType = PredefinedSkillType;


}

angular
  .module('bringoz.admin.skills')
  .component('skillsTableRow', {
    require: {
      skillsTableCtrl: '^skillsTable'
    },
    bindings: {
      skill: '<'
    },
    template: require('./skills-table-row.html').default,
    controller: SkillsTableRowCtrl
  });
